<aside class="filter-panel">
  <div class="filter-header">
    <!-- Optional: Clear All button could go here -->
  </div>

  <!-- Source Selection Toggle -->
  <div class="source-toggle">
    <button [class.active]="currentSource === 'yachts'" (click)="onSourceChange('yachts')">
      Yachts
    </button>
    <button
      [class.active]="currentSource === 'merchandises'"
      (click)="onSourceChange('merchandises')"
    >
      Merchandise
    </button>
  </div>

  <div class="filter-sections">
    <div *ngFor="let section of config" class="filter-group" [class.collapsed]="section.collapsed">
      <!-- Section Header -->
      <div class="group-header" (click)="toggleSection(section)">
        <h4>{{ section.label }}</h4>
        <span class="toggle-icon">{{ section.collapsed ? '+' : '−' }}</span>
      </div>

      <!-- Section Content -->
      <div class="group-content" *ngIf="!section.collapsed">
        <!-- CHECKBOX List -->
        <ng-container *ngIf="section.type === 'checkbox'">
          <div *ngFor="let opt of section.options" class="checkbox-item">
            <input
              type="checkbox"
              [id]="section.key + '-' + opt.value"
              [checked]="isChecked(section.key, opt.value)"
              (change)="onCheckboxChange(section, opt.value, $event)"
            />
            <label [for]="section.key + '-' + opt.value">
              {{ opt.label }}
            </label>
          </div>
        </ng-container>

        <!-- RADIO List -->
        <ng-container *ngIf="section.type === 'radio'">
          <div *ngFor="let opt of section.options" class="checkbox-item">
            <!-- Using checkbox style for radio visually if preferred, or actual radio inputs -->
            <input
              type="radio"
              [id]="section.key + '-' + opt.value"
              [checked]="isChecked(section.key, opt.value)"
              (change)="onCheckboxChange(section, opt.value, $event)"
            />
            <label [for]="section.key + '-' + opt.value">
              {{ opt.label }}
            </label>
          </div>
        </ng-container>

        <!-- RANGE Slider -->
        <ng-container *ngIf="section.type === 'range'">
          <div class="range-container">
            <div class="range-inputs">
              <input
                type="range"
                [min]="section.min"
                [max]="section.linear === false ? 100 : section.max"
                [step]="section.linear === false ? 1 : section.step || 1"
                [value]="getSliderValue(section)"
                (input)="onRangeChange(section.key, $event)"
              />
            </div>
            <div class="range-labels">
              <span *ngIf="section.key === 'year'">{{ section.min }}</span>
              <span *ngIf="section.key === 'year'">{{ getDisplayValue(section) }}</span>

              <span *ngIf="section.key === 'price'">{{
                section.min | currency: 'USD' : 'symbol' : '1.0-0'
              }}</span>
              <span *ngIf="section.key === 'price'">{{ formatMaxLabel(section) }}</span>
              <ng-container *ngIf="section.key !== 'year' && section.key !== 'price'">
                <span>{{ section.min }}</span>
                <span>{{ getDisplayValue(section) }}</span>
              </ng-container>
            </div>
          </div>
        </ng-container>

        <!-- RATING Stars -->
        <ng-container *ngIf="section.type === 'rating'">
          <div class="rating-filter-container">
            <div class="rating-stars-row">
              <div
                *ngFor="let star of [1, 2, 3, 4, 5]"
                class="rating-item-wrapper"
                [class.active]="star <= getDisplayValue(section)"
                (click)="onRatingChange(section.key, star)"
                (mouseenter)="hoverRating = star"
                (mouseleave)="hoverRating = 0"
              >
                <i
                  class="fas fa-star"
                  [style.color]="
                    (hoverRating > 0 ? star <= hoverRating : star <= getDisplayValue(section))
                      ? '#facc15'
                      : '#e5e7eb'
                  "
                ></i>
                <span class="rating-number">{{ star }}</span>
              </div>
            </div>
            <div class="rating-text-label" *ngIf="getDisplayValue(section) > 0">
              {{ getDisplayValue(section) }} & Above
            </div>
            <div class="rating-text-label" *ngIf="getDisplayValue(section) === 0">Any Rating</div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>

  <!-- Footer Actions -->
  <div class="filter-footer">
    <button class="btn-clear" (click)="onClearAll()">Clear All</button>
  </div>
</aside>
